import React from 'react';
import useFilterBullets from '../../hooks/useFilterBullets';
import { CusProductListFilterBulletsProps } from '../../cus-product-list.data';

export default function FilterBullets({
    activeFilters,
    currency,
    categoryNames,
    onRemove,
    onClearAll,
    clearAllFiltersText
}: CusProductListFilterBulletsProps) {
    const { bullets, handleRemove } = useFilterBullets({ activeFilters, currency, categoryNames, onRemove });

    if (bullets.length === 0) {
        return null;
    }

    return (
        <div className='bs-filter-bullets'>
            {bullets.map(bullet => (
                <button key={bullet.key} type='button' className='bs-filter-bullets__item' onClick={() => handleRemove(bullet.key)}>
                    <span className='bs-filter-bullets__item__label'>{bullet.label}</span>
                    <span className='bs-filter-bullets__item__remove' aria-hidden='true' />
                </button>
            ))}
            <button type='button' className='bs-filter-bullets__clear' onClick={onClearAll}>
                {clearAllFiltersText}
            </button>
        </div>
    );
}
